type Constructor<T> = new (...args: unknown[]) => T

function TypeGuard<T>(o: unknown, className: Constructor<T>): o is T {
  return o instanceof className
}

export default class ServiceProvider {
  private services = new Map<Constructor<unknown>, unknown>()

  register<T>(name: Constructor<T>, builder: () => T) {
    this.services.set(name, builder())
  }

  get<T>(): T {
    for (const [key, value] of this.services) {
      if (TypeGuard<T>(value, key as Constructor<T>)) {
        return value
      }
    }

    throw new Error('Inexistent dependency')
  }
}

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $services: ServiceProvider
  }
}
